import { useSelector } from "react-redux";

import { getNodeValueSelector } from "./valueSelectors.ts";

export const useGetNodeValue = () => useSelector(getNodeValueSelector);
